
<script>
/**
  label: '处理沟通截图', prop: 'imgs', type: 'pasteUpload',
  propOptions: {
    name: 'filedata',
    tip: '只能上传jpeg、jpg、png文件',
    accept: '.jpeg,.jpg,.png',
    uploadApi: uploadfile,
  }
*/
export default {
  name: 'Upload',
  props: ['value', 'propOptions', 'btnText', 'item'],
  data() {
    return {
      fileList: [],
      curFileUrl: undefined,
      curFileIndex: undefined,
      upLoading: false,
    }
  },
  computed: {
    fileListUrl() {
      return this.fileList.map(item => item.url)
    },
    name () {
      return this.propOptions?.name || 'file'
    },
    limit () {
      return this.propOptions?.limit || 1
    },
    inputProp () {
      let parmas = {
        accept: this.propOptions?.accept,
        limit: this.limit,
        name: this.name,
      }
      return parmas
    },
    btnDisabled () {
      return this.fileList.length >= this.limit
    }
  },
  created() {
    this.fileList = JSON.parse(JSON.stringify(this.value || []))
  },
  mounted() {
    document.body.addEventListener('paste', this.handlePaste)
    let pasteBox = document.getElementById('pasteBox')
    this.alreadyPaste = false
    if (pasteBox) {
      pasteBox.addEventListener('mouseover', () => {
        this.alreadyPaste = true
      })
      pasteBox.addEventListener('mouseout', (event) => {
        if (event.target instanceof Element && event.target.parentNode !== pasteBox) {
          this.alreadyPaste = false
        } else {
          this.alreadyPaste = true
        }
      })
    }
  },
  beforeDestroy() {
    document.body.removeEventListener('paste', this.handlePaste)
  },
  methods: {
    updateFiles(files) {
      let newValue = files.map(file => ({
        name: file.name,
        url: file.url || file.response?.data?.url,
      }))
      this.$emit('input', newValue)
    },
    onClick() {
      this.$refs.refInput.click()
    },
    onInputChange(event) {
      let file = event.target.files[0]
      if (file) {
        this.handleUpload(file)
      }
    },
    handlePaste(event) {
      console.log(`粘贴上传触发中: alreadyPaste: ${this.alreadyPaste}`);
      if (!this.alreadyPaste) return
      let clipboardData =
        event.clipboardData ||
        event.originalEvent.clipboardData ||
        window.clipboardData;
      const file = clipboardData.files.length > 0 && clipboardData.files[0];
      if (file) {
        this.handleUpload(file)
      } else {
        console.log('粘贴板中没有文件：', clipboardData,)
      }
    },
    httpRequest(file) {
      if (this.propOptions?.httpRequest) {
        return this.propOptions.httpRequest
      }
      if (!this.propOptions?.uploadApi) {
        console.error('清先传入propOptions.uploadApi')
        return false
      }
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async (e) => {
          let filedata = e.target.result;
          let params = {}
          params[this.name] = filedata
          try {
            let res = await this.propOptions.uploadApi(params)
            if (res.code !== 200) {
              throw new Error()
            }
            resolve(res)
          } catch {
            reject(false)
          }
        }
      })
    },
    async handleUpload(file) {
      if (this.upLoading) return
      if (this.btnDisabled) {
        this.$message.error(`只允许上传${this.limit}张图片`)
        return
      }
      try {
        this.upLoading = true
        let { data } = await this.httpRequest(file)
        this.fileList.push({
          name: file.name,
          url: data.url
        })
        this.$message.success('上传成功')
        this.updateFiles(this.fileList)
      } finally {
        this.upLoading = false
      }
    },
    showImage(file, index) {
      this.curFileUrl = file.url
      this.curFileIndex = index
      this.$nextTick(() => {
        this.$refs['refImage'].clickHandler()
      })
    },
    handleRemove (file) {
      let index = this.fileList.indexOf(file)
      this.fileList.splice(index, 1)
      this.updateFiles(this.fileList)
    },
      
  },
}
</script>

<template>
  <div>
    <div v-show="!btnDisabled">
      <div :class="$style.pasteUpload__outer" class="el-upload-dragger h150" id="pasteBox">
        <i class="el-icon-upload mt25"></i>
        <div v-if="upLoading">上传中...</div>
        <div v-else class="el-upload__text pointer" @click="onClick">鼠标移入此处粘贴截图，或 <em>点击上传</em></div>
      </div>
      <div slot="tip" :class="$style.pasteUpload__tip" v-if="propOptions && propOptions.tip">{{ propOptions.tip }}</div>
      <input
        type="file"
        v-bind="inputProp"
        ref="refInput"
        :class="$style.pasteUpload__input"
        @change="onInputChange"
      />
    </div>
    <ul :class="$style.pasteUpload__files__ul">
      <li
        :class="$style.pasteUpload__files__li"
        v-for="(item, index) in fileList"
        :key="index"
      >
        <img :src="item.url" />
        <label :class="$style.pasteUpload__files__status">
          <i class="el-icon-check"></i>
        </label>
        <div :class="$style.pasteUpload__files__li__cover">
          <i class="el-icon-zoom-in pointer" @click="showImage(item, index)"></i>
          <i class="el-icon-delete pointer" @click="handleRemove(item)"></i>
        </div>
      </li>
    </ul>
    <el-image
      v-if="curFileUrl"
      v-show="false"
      ref="refImage"
      :src="curFileUrl"
      :initial-index="curFileIndex"
      :previewSrcList="fileListUrl">
    </el-image>
  </div>
</template>

<style lang="scss" module>
.pasteUpload__outer {
  cursor: default;
}
.pasteUpload__input {
  display: none;
  visibility: hidden;
}
.pasteUpload__tip {
  font-size: 12px;
  text-align: left;
}
.pasteUpload__files__ul,
.pasteUpload__files__li {
    list-style: none;
    margin: 0;
    padding: 0;
}

.pasteUpload__files__li{
  position: relative;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 120px;
  height: 120px;
  margin: 0 8px 8px 0;
  display: inline-block;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .pasteUpload__files__li__cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    background-color: rgba(0,0,0,0.5);
    font-size: 20px;
    color: #fff;
    opacity: 0;
    transition: opacity .3s;
  }
  .pasteUpload__files__status {
    position: absolute;
    right: -15px;
    top: -6px;
    width: 40px;
    height: 24px;
    background: #13ce66;
    text-align: center;
    transform: rotate(45deg);
    box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);
    i {
      font-size: 12px;
      margin-top: 11px;
      transform: rotate(-45deg);
      color: #fff;
    }
  }
  &:hover {
    .pasteUpload__files__status {
      opacity: 0;
    }
    .pasteUpload__files__li__cover{
      opacity: 1;
    }
  }

}
</style>